import { Box, Select } from "@mantine/core";
import { useAtom } from "jotai";
import { TFunction } from "react-i18next";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { insuranceTypeToActivateAtom } from "atoms/insuranceTypeToActivate";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";
import { useEventTracking } from "hooks/useEventTracking";
import { InsuranceType } from "types/DigitalJourneySession";

export const getInsuranceToActivate = (t: TFunction) => {
  return [
    {
      label: "Kasko",
      value: InsuranceType.KASKO,
    },
    {
      label: "Mini Kasko (Collisione)",
      value: InsuranceType.COLLISION,
    },
  ];
};

export const DJTypeOfClaimInsuranceToActivate = () => {
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const { onNext, continueCTA } = useDigitalJourneyPageRouting();
  const [insuranceType, setInsuranceType] = useAtom(insuranceTypeToActivateAtom);
  const isDisabled = insuranceType === null;

  const onContinue = () => {
    trackEvent({ name: "Digital Journey Type of Claim Insurance to Activate - continue" });
    onNext();
  };

  return (
    <PageLayout contentSpacing="space-between">
      <Flex px={24} py={24} gap={16} flex={1} mb={16}>
        <Text as="h1" sizeVariant="xl" weight={600}>
          Informazioni sul sinistro
        </Text>
        <Box>
          <Flex gap={16} role="radiogroup" aria-labelledby="typeOfClaim">
            <Select
              name="insuranceType"
              label="Tipo di garanzia da attivare"
              placeholder={t("digital_journey.accident_information.select")}
              data={getInsuranceToActivate(t)}
              value={insuranceType}
              onChange={(value) => setInsuranceType(value as InsuranceType)}
            />
          </Flex>
        </Box>
      </Flex>
      <Flex px={24} py={24} gap={16}>
        <Button disabled={isDisabled} onClick={onContinue}>
          {continueCTA}
        </Button>
      </Flex>
    </PageLayout>
  );
};
